import React from 'react';
import styled from 'styled-components';
import { useNoHeaderModules } from '../../hooks/noHeaderModules';
import { CONTENT_STANDARD, CONTENT_FULL } from '../../utils/media';

const SectionWrapper = styled.div`
  background: ${(props) => props.$background};
  width: 100%;
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 3rem 1rem;

  max-width: ${({ $size }) => ($size !== CONTENT_FULL ? `${$size}px` : $size)};
  gap: ${(props) => props.$gap || 0}px;
  align-items: ${({ $align }) => $align};
`;

const PageSection = ({ children, align, gap, size, backgroundColor }) => {
  const noHeader = useNoHeaderModules();

  return (
    <SectionWrapper $background={backgroundColor}>
      <SectionContent $align={align || 'center'} $gap={gap} $size={size || CONTENT_STANDARD} $noHeader={noHeader}>
        {children}
      </SectionContent>
    </SectionWrapper>
  );
};

export default PageSection;
